import { Record } from 'immutable';
import remove from 'lodash/fp/remove';
import isEmpty from 'lodash/fp/isEmpty';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  websites: [],
  website: {
    id: null,
  },
  tmpWebsite: {},
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
  availableFonts: [],
  availableThemes: [],
});

const websitesReducer = (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.WEBSITES_SUCCESS:
    case types.WEBSITES_LIGHT_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('websites', payload);
    case types.WEBSITE_UPDATE_TMP_REQUEST: {
      const mergedTmpWebsite = isEmpty(payload.tmpWebsite)
        ? payload.tmpWebsite
        : { ...state.tmpWebsite, ...payload.tmpWebsite };
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('tmpWebsite', mergedTmpWebsite);
    }
    case types.SET_WEBSITE_THEME_REQUEST: {
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    }
    case types.WEBSITE_SUCCESS:
    case types.UPDATE_WEBSITE_SUCCESS: {
      const feeds = payload.Feeds ? payload.Feeds.map((f) => f.id) : undefined;
      const website = { ...payload, feeds };
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('tmpWebsite', website)
        .set('website', website);
    }
    case types.CREATE_WEBSITE_SUCCESS: {
      const feeds = payload.Feeds ? payload.Feeds.map((f) => f.id) : undefined;
      const website = { ...payload, feeds };
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('tmpWebsite', website)
        .set('website', website)
        .set('websites', [...state.websites, website]);
    }
    case types.SET_WEBSITE_THEME_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, true)
        .set(constants.FETCHING_KEY, false)
        .set('website', { ...payload });
    case types.DELETE_WEBSITE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('websites', remove({ id: payload })(state.websites));
    case types.AVAILABLE_FONTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set('availableFonts', payload);
    case types.AVAILABLE_THEMES_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set('availableThemes', payload);
    case types.SET_WEBSITE_THEME_FAILURE:
      return state
        .set('website', state.website)
        .set(constants.ERROR_KEY, payload)
        .set(constants.FETCHING_KEY, false);
    case types.WEBSITES_REQUEST:
    case types.WEBSITES_LIGHT_REQUEST:
    case types.WEBSITE_REQUEST:
    case types.CREATE_WEBSITE_REQUEST:
    case types.UPDATE_WEBSITE_REQUEST:
    case types.DELETE_WEBSITE_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.WEBSITES_FAILURE:
    case types.WEBSITES_LIGHT_FAILURE:
    case types.WEBSITE_FAILURE:
    case types.CREATE_WEBSITE_FAILURE:
    case types.UPDATE_WEBSITE_FAILURE:
    case types.DELETE_WEBSITE_FAILURE:
    case types.AVAILABLE_FONTS_FAILURE:
    case types.AVAILABLE_THEMES_FAILURE:
      return state
        .set(constants.ERROR_KEY, payload)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.RESET_WEBSITE:
      return state
        .set('website', requestReducerState().website)
        .set(constants.ERROR_KEY, null)
        .set(constants.SUCCESS_KEY, null)
        .set(constants.FETCHING_KEY, false);
    default:
      return state;
  }
};

export default websitesReducer;
